import { render, staticRenderFns } from "./EditAssociatedProperty.vue?vue&type=template&id=01d4e009"
import script from "./EditAssociatedProperty.vue?vue&type=script&lang=js"
export * from "./EditAssociatedProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports